<div class="single__page">
  <img width="10%" src="/assets/images/eurofarma-assets/eurofarma.png" alt="Eurofarma logo">
  <p>
    Você foi deslogado.
  </p>
  <a [routerLink]="['/login']">Logar novamente</a>
</div>
